

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { i18nMixin } from '@/modules/neodash/mixins';
import {
  columnGoalSetting,
  EconomicGroup,
  IEconomicGroupGoalsDetails,
  Families,
  Family,
  inputColumnGoalSetting,
  inputManualColumnGoalSetting,
  labelColumnGoalSetting,
  numberColumnGoalSetting,
  numberValuedColumnGoalSetting,
  percentColumnGoalSetting,
} from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/types';
import { GoalSettingColumns } from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/GoalSettingColumns';
import ValueEditionGoalSetting from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/value-edition-goal-setting.component.vue';
import { NumberHelper } from '@/utils/number.helper';
import { SaleTypeEnum } from '@/modules/neodash/model/types/enums/saleTypeEnum';
import { isInput, styleCellFactory } from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/utils';
import { goalTypeEnum } from '@/modules/business-plan/modules/models/enums/goalTypeEnum';
import Icon from '@/modules/business-plan/common/utils/icon.component.vue';
import numeral from 'numeral';
const t = i18nMixin.methods.i18n;
@Component({
  name: 'TableViewBodyGoalSettingComponent',
  components: { Icon, ValueEditionGoalSetting }
})
export default class TableViewBodyGoalSettingComponent extends Vue {
  public numeral = numeral;
  public isInput = isInput;

  @Prop({ required: true })
  public columns: GoalSettingColumns;

  @Prop({ required: true })
  public economicGroup: EconomicGroup;

  @Prop({ required: true })
  public families: Families;

  public styleCell = styleCellFactory(this.columns);
  public getValueArbitratedGoal(column: columnGoalSetting, family: Family): number | string {
    const lst: IEconomicGroupGoalsDetails[] = this.getSalesGroupIndustryGoalData(family);
    let sum = lst.filter(c => c.inputValue && c.inputValue > 0).sumBy(c => c.goalValue);
    return sum === 0 ? '' : numeral(sum / 12).format('0.0');
  }

  public getValue(column: columnGoalSetting, family: Family): number | string {
    const { hide } = column as numberValuedColumnGoalSetting;
    if (hide && hide(family)) {
      return '';
    }

    const lst: IEconomicGroupGoalsDetails[] = this.getSalesGroupIndustryGoalData(family);

    if ((column as labelColumnGoalSetting).getterLabel)
      return (column as labelColumnGoalSetting).getterLabel(family);

    if ((column as numberColumnGoalSetting).getterValuePerMonth)
      return lst.sumBy((column as numberColumnGoalSetting).getterValuePerMonth);

    if ((column as percentColumnGoalSetting).getterOver) {
      const { familiesToHide } = this.columns;
      if (familiesToHide.includes(family.id)) {
        return '-';
      }

      const c = column as percentColumnGoalSetting;
      const total = lst.sumBy(c.getterTotal);
      const over = lst.sumBy(c.getterOver);

      if (c.withSubtract) {
        if (over === 0) {
          return numeral(0).format('0.0%');
        }

        return numeral((total / over) - 1).format('0.0%');
      }

      return NumberHelper.percent(total, over);
    }

    return 'Not registered';
  }

  public getInputShare(column: inputColumnGoalSetting, family: Family): string {
    const { hide, hideByFamily } = column as numberValuedColumnGoalSetting;
    if (hide && hide(family))
      return '';

    if (hideByFamily && hideByFamily(family)) {
      return '';
    }

    const lst: IEconomicGroupGoalsDetails[] = this.getSalesGroupIndustryGoalData(family);
    if ((column as inputManualColumnGoalSetting).isManualInput) {
      if (lst.length > 1) {
        if (lst[0].goalTypeSelected !== goalTypeEnum.Manual && lst[1].goalTypeSelected !== goalTypeEnum.Manual)
          return '';
      } else {
        if (lst[0].goalTypeSelected !== goalTypeEnum.Manual) return '';
      }
    }
    const total = lst.sumBy(this.columns.getInputShareTotalProp);
    const over = lst.sumBy(column.getterOver);
    return NumberHelper.percent(total, over);
  }

  public getSalesGroupIndustryGoalData(family: Family): IEconomicGroupGoalsDetails[] {
    const details = this.economicGroup.details.filter(x =>
      x.idFamily === family.id
      && (x.idSaleType === this.columns.saleType.value || this.columns.saleType.value === SaleTypeEnum.AllOfIt));

    return details.map(x => ({ ...x, familyRuleValue: family.rules[0].valueMinimum }));
  }
}
